<template>
  <div>
    <nav-breadcrumb :menu="[{label: '银行账户管理'}]"/>
    <el-row>
      <bank-account-data-table
        :data="bankAccountList"
        @onUpdate = "onUpdate"
        @onDelete = "onDelete"
      />
    </el-row>
    <div class="tr">
      <button-back/>
    </div>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import {removeItem} from "../../../filters/CommonActions";
  import BankAccountDataTable from '../../components/BankAccountDataTable'
  import ButtonBack from "../../../components/ButtonBack";

  export default {
    name: "BankAccountList",
    data(){
      return {
        bankAccountList: {},
      }
    },
    components: {
      ButtonBack,
      BankAccountDataTable
    },
    mounted() {
      this.getBankAccountList()
    },
    methods: {
      getBankAccountList: function () {
        xhr.getBankAccountList({},res=>{
          try{
            if(res.data.status == 'success') {
              this.bankAccountList = res.data ||{}
            }
          }catch (e) {

          }
        })
      },
      onUpdate: function (data) {
        xhr.updateBankAccount(
          data,
          res=>{
            try {
              if(res.data.status == 'success') {
                this.getBankAccountList()
              }
            }catch (e) {

            }
          }
        )
      },
      onDelete: function (row) {
        removeItem(
          xhr.deleteBankAccount,
          {
            'ba.accountId': row.ba__accountId
          },
          ()=>{
            this.getBankAccountList()
          }
/*          res=>{
            try{
              console.log(res)
              if(res.data.status == 'success') {
                console.log(res.data.rflag)
                let updates = res.data.rflag.updates
                if(updates < 1) {
                  let msg = '操作失败，可能该银行账号正被使用！'
                  this.$message({
                    message: msg,
                    type: 'primary'
                  })
                }
                else {
                }
                this.getBankAccountList()
              }
            }catch (e) {

            }
          }*/
        )
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/BankAccountList.vue